<template>
  <div @click="_close_explain" v-if="showing">
    <div>
      <modal-mask></modal-mask>
    </div>

    <div class="bind-account" :style="`background: url(${baseUrl.portalImg}${h5ConfigImgPath}/${h5ConfigDetails[0]['llkPicture']['llkBindModalBg'][0]}) 0 0 no-repeat;background-size: contain;`">
      <img class="close" :src="require('@/assets/livelink/close.png')" alt="" @click="_close">
      <!-- <img class="title" :src="require('@/assets/livelink/title.png')" alt=""> -->
      <div class="account">1.登录迅游手游加速器账号: <span :style="`color: ${h5ConfigDetails[0]['llkText']['llkTextColor'][0]}`" class="nickname-ellipsis"> {{userInfo.userDisplayName || userInfo.userName}}</span></div>

      <div class="bind-role">
        <div>3.绑定游戏角色: </div>
        <img v-if="!bindRoleInfo || !bindRoleInfo.roleName" :src="`${baseUrl.portalImg}${h5ConfigImgPath}/${h5ConfigDetails[0]['llkPicture']['llkBindBtn'][0]}`" alt="" @click="_bind_account">
        <span v-if="bindRoleInfo && bindRoleInfo.roleName" class="nickname-ellipsis" :style="`color: ${h5ConfigDetails[0]['llkText']['llkTextColor'][0]}`">{{bindRoleInfo.roleName}}</span>
        <img v-if="bindRoleInfo && bindRoleInfo.roleName" :src="`${baseUrl.portalImg}${h5ConfigImgPath}/${h5ConfigDetails[0]['llkPicture']['llkToggleBtn'][0]}`" alt="" @click="_bind_account">
      </div>
      <div class="notice">绑定规则说明 <img class="questions-icon" :src="require('@/assets/livelink/question.png')" alt="" @click.stop="_show_explain">
        <div class="questions" v-if="explainVisibility">
          <img :src="require('@/assets/livelink/questions-bg.png')" alt="">
          <div>一旦您点击完成绑定，视为您同意我们从livelink获取您 的”绑定游戏角色信息“(即您登录的迅游手游加速器账号 通过livelink已经绑定的游戏账号的角色信息，
            包括昵称 、区服信息)和对应账号绑定关系，用于在本活动页面展 示、参与活动和领取奖励；请您确认绑定游戏角色信息 无误。如您在参与活动期间变更了您已绑定的游戏账号 
            的角色信息（例如区服信息），则本活动绑定游戏角色 将自动更新，但livelink中该游戏的角色信息不会同步变 更（您需要在livelink另外进行变更）。</div>
        </div>
      </div>

      <div class="account-both">
        <img class="account-bg" :src="require('@/assets/livelink/account-bg.png')" alt="">
        <div :style="`color: ${h5ConfigDetails[0]['llkText']['llkTextColor'][0]}`"><span class="nickname-ellipsis">{{userInfo.userDisplayName || userInfo.userName}}</span> <span style="margin: 0 .4rem;">&</span> <span class="nickname-ellipsis-long">{{(bindRoleInfo && `${bindRoleInfo.areaName}-${bindRoleInfo.platName}-${bindRoleInfo.roleName}`) || '未绑定游戏角色'}}</span></div>
      </div>
      <div class="limit">每5分钟可绑定一次账号，请确认账号无误</div>

      <div class="agrement">
        <img :src="require(readed ? '@/assets/livelink/choose.png' : '@/assets/livelink/no-choose.png')" alt="" @click="readed = !readed">
        <div>阅读并同意 <span :style="`color: ${h5ConfigDetails[0]['llkText']['llkTextColor'][0]}`" @click="_go_agrement">《服务协议》</span></div>
      </div>

      <img class="btn" :src="`${baseUrl.portalImg}${h5ConfigImgPath}/${h5ConfigDetails[0]['llkPicture']['llkFinishBtn'][0]}`" alt="" @click="_finish_bind">
      <div class="customer" @click="_go_customer">绑定有问题 <img :src="require('@/assets/livelink/question.png')" alt=""></div>

      <confirm-modal ref="confirmModal"></confirm-modal>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import appBridge from '@/config/appBridge'
import ConfirmModal from '@/components/liveLink/ConfirmModal'
import ModalMask from '@/components/modal/ModalMask'
import { baseUrl } from '@/config/env'
import { global } from '@/config/global'

export default {
  name: 'BindAccountModal',

  props: {
  },
  components: { ConfirmModal, ModalMask },
  data () {
    return {
      baseUrl: baseUrl,
      showing: false,
      readed: false,
      explainVisibility: false
    }
  },
  created () {

  },
  mounted () {

  },
  methods: {
    show () {
      this.showing = true
    },
    _close () {
      this.showing = false
    },
    _go_customer () {
      appBridge.turnToAppZhiChiPage()
    },
    _go_agrement () {
      appBridge.appToWebPlus(this.h5ConfigDetails[0]['llkText']['serverAgrementUrl'][0])
    },
    _show_explain () {
      this.explainVisibility = true
    },
    _close_explain () {
      if (this.explainVisibility) {
        this.explainVisibility = false
      }
    },
    _bind_account () {
      if (!this.canPerformOperation()) {
        this.$toast('抱歉，绑定5分钟内不可换绑')
        return
      }

      this.$refs.confirmModal.show()
    },
    _finish_bind () {
      if (!this.isLogin) {
        this.$toast('您的账号未登录')
        return
      }

      if (!this.isBinded) {
        this.$toast('您的游戏角色未绑定')
        return
      }

      if (!this.readed) {
        this.$toast('您未勾选服务协议')
        return
      }

      this.showing = false
    },
    canPerformOperation() {
      const lastOperationTime = localStorage.getItem(`${global.LOCAL_STORAGE_FLAG_BASE}-${this.h5ConfigDetails[0]['llkText']['activityId'][0] || ''}`)

      if (lastOperationTime) {
        const now = new Date();
        const lastTime = new Date(parseInt(lastOperationTime, 10));
        const difference = now - lastTime; // 毫秒差
        const minutesDifference = difference / 1000 / 60; // 转换成分钟

        if (minutesDifference < 5) {
          // 如果距离上次操作时间少于5分钟
          return false; // 不允许操作
        }
      }
      // 如果没有记录或已超过5分钟，更新操作时间并允许操作
      return true; // 允许操作
    }
  },
  filter: {

  },
  computed: {
    ...mapState(['h5ConfigDetails', 'h5ConfigImgPath', 'userInfo', 'isLogin', 'bindRoleInfo']),
    ...mapGetters([
      'isBinded'
    ])
  },
  watch: {

  }
}
</script>

<style scoped lang="less">
  @import '../../style/mixin';

  .bind-account {
    .modal-common;
    width: 33.7rem;
    height: 38.1rem;
    background-size: contain;
    border-radius: 0rem;
    padding: 7.7rem 2.4rem 0;
  }

  .close {
    position: absolute;
    width: 1.5rem;
    height: 1.5rem;
    top: 2rem;
    right: 2rem;
  }

  .title {
    width: 21.6rem;
    margin: 2.1rem auto 2.3rem;
    display: block;
  }

  .notice, .limit {
    font-weight: 400;
    font-size: 1.1rem;
    color: #949AAA;
    text-align: left;
    margin-bottom: 1.5rem;
  }

  .notice {
    display: flex;
    flex-direction: row;
    align-items: center;
    position: relative;
  }

  .questions-icon {
    width: .9rem;
    height: .9rem;
    margin-left: 0.4rem;
  }

  .agrement {
    display: flex;
    align-items: center;
  }

  .agrement img {
    width: 1.1rem;
    height: 1.1rem;
  }

  .agrement div {
    font-size: 1.1rem;
    color: #FFFFFF;
    margin-left: 0.4rem;
  }

  .account-bg {
    width: 100%;
    height: 2.8rem;
    margin-bottom: 0.9rem;
  }

  .account, .bind-role {
    font-weight: 500;
    font-size: 1.1rem;
    color: #FFFFFF;
  }

  .account {
    margin-bottom: 1.6rem;
    display: flex;
    align-items: center;
  }

  .bind-role {
    margin-bottom: .8rem;
    display: flex;
    align-items: center;
  }

  .bind-role div {
    margin-right: 1.1rem;
  }

  .bind-role span {
    font-weight: 500;
    font-size: 1.1rem;
    margin-right: 1.7rem;
  }

  .bind-role img {
    height: 1.7rem;
  }

  .account span {
    font-weight: 500;
    font-size: 1.1rem;
    margin-left: 1rem;
  }

  .btn {
    height: 3.3rem;
    display: block;
    margin: 3.5rem auto .7rem;
  }

  .customer {
    font-weight: 400;
    font-size: 1.1rem;
    color: #949AAA;
    text-align: center;
  }

  .customer img {
    width: .9rem;
    height: .9rem;
    margin-left: .4rem;
  }

  .questions {
    position: absolute;
    top: 2rem;
    left: 0;
    z-index: 10;
  }

  .questions img {
    width: 28.4rem;
    height: 19rem;
  }

  .questions div {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    padding: 1.1rem;
    color: #FFF;
    line-height: 1.7rem;
  }

  .account-both {
    position: relative;
  }

  .account-both div {
    width: 100%;
    height: 2.8rem;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    font-weight: 500;
    font-size: 1.1rem;
    line-height: 2.8rem;
    text-align: center;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }
</style>
